import React, { useEffect, useRef, useState, Suspense } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import {
  ProfileIcons,
  ProfileIcons1,
  DMIFinance,
  InCred,
  MoneyView,
  LendingKart,
  SubmitLoan,
  DocumentsLoan,
  CreditHistory,
  OnlineDoc,
  WhyChoose,
  Bank,
  Money,
  EasyWay,
  ReferImage,
  EnquiryIcon,
  LoanProcessed,
  UsersIcons,
  WalletIcon,
  SuitCase,
  Mortage,
} from "../../assets/images";
import CountUp from "react-countup";
import VisibilitySensor from "react-visibility-sensor";
import CarouselComponent from "./CarouselComponent";
import Header from "./../layouts/header";
import Footer from "./../layouts/footer";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import LenderSection from "./sections/LenderSection";
import CoveredSection from "./sections/CoveredSection";
import PartnerSection from "./sections/PartnerSection";
import ContactModal from "./ContactModal";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
function Home(props) {
  const homeRef = useRef(null);
  const servicesRef = useRef(null);
  const mechanicsoneRef = useRef(null);
  const aboutRef = useRef(null);
  const [showModal, setShowModal] = useState(true);
  const [width, setWidth] = useState(window.innerWidth);
  function handleWindowSizeChange() {
    setWidth(window.innerWidth);
  }
  useEffect(() => {
    window.addEventListener("resize", handleWindowSizeChange);
    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
    };
  }, []);

  const isMobile = width <= 768;
  const [activeMenu, setActiveMenu] = useState("");
  var isInViewport = function (elem) {
    var distance = elem.getBoundingClientRect();
    return (
      distance.top >= 0 &&
      distance.left >= 0 &&
      distance.bottom <=
        (window.innerHeight || document.documentElement.clientHeight) &&
      distance.right <=
        (window.innerWidth || document.documentElement.clientWidth)
    );
  };
  useEffect(() => {
    window.scrollTo({
      behavior: "smooth",
      top: 0,
    });
    var findMe = document.querySelectorAll(".lender-row");
    var findMeT = document.querySelectorAll(".right-animation");

    window.addEventListener(
      "scroll",
      function (event) {
        if (!isMobile) {
          findMe.forEach((element) => {
            if (isInViewport(element)) {
              element.classList.add("animate");
            }
          });
          findMeT.forEach((element) => {
            let dis = element.getBoundingClientRect();
            if (dis?.top < 550) {
              element.classList.add("animate");
            }
          });
        }
      },
      false,
    );
  }, []);
  const offsetValue = 300;
  function handleScroll(event) {
    let mechanicsOffset = mechanicsoneRef.current?.getBoundingClientRect();
    let servicesOffset = servicesRef.current?.getBoundingClientRect();
    let homeOffset = homeRef.current?.getBoundingClientRect();
    let aboutOffset = aboutRef.current?.getBoundingClientRect();

    if (homeOffset && homeOffset.top > -offsetValue) {
      setActiveMenu("home");
    }
    if (servicesOffset && servicesOffset.top < offsetValue) {
      setActiveMenu("services");
    }
    if (mechanicsOffset && mechanicsOffset.top < offsetValue) {
      setActiveMenu("mechanicsone");
    }
    if (aboutOffset && aboutOffset.top < offsetValue) {
      setActiveMenu("about-us");
    }
  }

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    // Cleanup function
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const [activeSlider, setActiveSlider] = useState(0);
  const [defActive, setDefActive] = useState(0);
  const onSlideFunction = (e) => {
    setActiveSlider(e);
  };
  const handleActive = (activeIndex) => {
    setActiveSlider(activeIndex);
    setDefActive(activeIndex);
  };
  const handleSelect = (selectedIndex, e) => {
    setDefActive(selectedIndex);
  };
  // ✅ Clean data-only structure
  const carouselItems = [
    {
      id: 1,
      lines: [
        "Discover Your Perfect Loan",
        "Solution Quickly And",
        "Effortlessly!",
      ],
      highlights: ["Perfect Loan"],
    },
    {
      id: 2,
      lines: ["Zero legwork with", "lenders"],
      highlights: ["lenders"],
    },
    {
      id: 3,
      lines: ["Enhance Your Earnings,", "Empower Your Business"],
      highlights: ["Earnings", "Business"],
    },
    {
      id: 4,
      lines: ["One platform for all your", "borrowing needs"],
      highlights: ["One", "borrowing"],
    },
  ];

  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  };

  const owlCarouselItems = [
    {
      id: 1,
      userName: (
        <p>
          "I paid on my private student loan for years and got nowhere. I
          defaulted and tried to negotiate the loans myself, but was
          unsuccessful. I hired Mr. Tate and he got me a better settlement than
          I expected."
        </p>
      ),
      userReview: <p className="userNameTest">Sneha</p>,
      img: ProfileIcons1,
    },
    {
      id: 2,
      userName: (
        <p>
          "I paid on my private student loan for years and got nowhere. I
          defaulted and tried to negotiate the loans myself, but was
          unsuccessful. I hired Mr. Tate and he got me a better settlement than
          I expected."
        </p>
      ),
      userReview: <p className="userNameTest">Anna Doe</p>,
      img: ProfileIcons,
    },
    {
      id: 3,
      userName: (
        <p>
          "I paid on my private student loan for years and got nowhere. I
          defaulted and tried to negotiate the loans myself, but was
          unsuccessful. I hired Mr. Tate and he got me a better settlement than
          I expected."
        </p>
      ),
      userReview: <p className="userNameTest">Anna Doe</p>,
      img: ProfileIcons,
    },
    {
      id: 4,
      userName: (
        <p>
          "I paid on my private student loan for years and got nowhere. I
          defaulted and tried to negotiate the loans myself, but was
          unsuccessful. I hired Mr. Tate and he got me a better settlement than
          I expected."
        </p>
      ),
      userReview: <p className="userNameTest">Sneha</p>,
      img: ProfileIcons1,
    },
    {
      id: 5,
      userName: (
        <p>
          "I paid on my private student loan for years and got nowhere. I
          defaulted and tried to negotiate the loans myself, but was
          unsuccessful. I hired Mr. Tate and he got me a better settlement than
          I expected."
        </p>
      ),
      userReview: <p className="userNameTest">Anna Doe</p>,
      img: ProfileIcons,
    },
    {
      id: 6,
      userName: (
        <p>
          "I paid on my private student loan for years and got nowhere. I
          defaulted and tried to negotiate the loans myself, but was
          unsuccessful. I hired Mr. Tate and he got me a better settlement than
          I expected."
        </p>
      ),
      userReview: <p className="userNameTest">Anna Doe</p>,
      img: ProfileIcons,
    },
    {
      id: 7,
      userName: (
        <p>
          "I paid on my private student loan for years and got nowhere. I
          defaulted and tried to negotiate the loans myself, but was
          unsuccessful. I hired Mr. Tate and he got me a better settlement than
          I expected."
        </p>
      ),
      userReview: <p className="userNameTest">Anna Doe</p>,
      img: ProfileIcons,
    },
  ];

  const bankCarouselItems = [
    { id: 9, img: DMIFinance },
    { id: 7, img: InCred },
    { id: 4, img: MoneyView },
    { id: 1, img: LendingKart },
  ];
  return (
    <>
      <Helmet>
        <title>
          FinLab - Trusted Financial Solutions for Businesses & Individuals
        </title>
        <meta
          name="description"
          content="FinLab offers reliable financial solutions for businesses and individuals. Explore our range of loan options and find the perfect fit for your needs."
        />
        <meta
          name="keywords"
          content="financial solutions, business loans, personal loans, reliable loans, FinLab"
        />
        <link rel="canonical" href="https://www.finlab.one/" />
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "Organization",
              "name": "FinLab",
              "url": "https://finlab.one",
              "logo": "https://finlab.one/logo.png",
              "contactPoint": {
                "@type": "ContactPoint",
                "telephone": "+919837010594",
                "contactType": "Customer Service"
              },
              "sameAs": [
                "https://www.facebook.com/finlab",
                "https://twitter.com/finlab"
              ]
            }
          `}
        </script>
      </Helmet>
      <div className="hero_area" ref={homeRef}>
        <Header activeMenu={activeMenu} />
        <div className="checkdiv">
          <div className="backy">
            <section className="slider_section " id="slider_section">
              <CarouselComponent
                handleSelect={handleSelect}
                defActive={defActive}
                onSlideFunction={onSlideFunction}
                carouselItems={carouselItems}
              />
              <div className="threeCards">
                <div className="basicCards purpleFirst">
                  <img src={WalletIcon} alt="WalletIcon" loading="lazy" />
                  <h4>
                    Personal
                    <br />
                    Loan
                  </h4>
                </div>
                <div className="basicCards green">
                  <img src={SuitCase} alt="SuitCase" loading="lazy" />
                  <h4>Business Loan</h4>
                </div>
                <div className="basicCards purpleSecond">
                  <img src={Mortage} alt="Mortage" loading="lazy" />
                  <h4>SME LAP</h4>
                </div>
              </div>
              <div className=" slider_circle">
                <ol className="carousel-indicators slider_circle_ol">
                  <li
                    onClick={() => handleActive(0)}
                    className={activeSlider === 0 ? "active" : ""}
                  ></li>
                  <li
                    onClick={() => handleActive(1)}
                    className={activeSlider === 1 ? "active" : ""}
                  ></li>
                  <li
                    onClick={() => handleActive(2)}
                    className={activeSlider === 2 ? "active" : ""}
                  ></li>
                  <li
                    onClick={() => handleActive(3)}
                    className={activeSlider === 3 ? "active" : ""}
                  ></li>
                </ol>
                <div className="avail-slider">
                  <Link to="/login">
                    <span className="avialNow">
                      <span className="avaitetxs">
                        Avail
                        <br />
                        Offers
                      </span>
                    </span>
                  </Link>
                </div>
              </div>
            </section>
          </div>
          <LenderSection />
          <CoveredSection />
          <PartnerSection
            bankCarouselItems={bankCarouselItems}
            isMobile={isMobile}
          />

          <section className="machanics" ref={mechanicsoneRef}>
            <div className="machanics-inner">
              <div className="container">
                <div className="row">
                  <div className="col-md-12">
                    <h2 className="green-border black-border">
                      Simplifying the Loan Journey just for you
                    </h2>
                  </div>
                </div>
                <div className="row mechanics-border-first ">
                  <div className="col-lg-6 col-md-6 left first-dotted-spaced  sub-head-mechanics">
                    <div className="macheincs-content number-one">
                      <h3>Submit Loan Details Online</h3>
                      <p>
                        {" "}
                        Kick-start your financial journey with a few clicks. Our
                        user-friendly platform makes it easy to provide your
                        loan requirements.
                      </p>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="macheincs-content imagepart">
                      <img src={SubmitLoan} alt="SubmitLoan" loading="lazy" />
                    </div>
                  </div>
                </div>

                <div className="row mechanics-border-second">
                  <div className="col-lg-6 col-md-6 second-dotted-spaced order-sec-2">
                    <div className="macheincs-content imagepart">
                      <img
                        src={DocumentsLoan}
                        alt="DocumentsLoan"
                        loading="lazy"
                      />
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6 sub-head-mechanics">
                    <div className="macheincs-content number-two">
                      <h3>Online Document Submission</h3>
                      <p>
                        {" "}
                        Streamline the approval process by uploading your
                        documents securely online, saving you time and effort.
                      </p>
                    </div>
                  </div>
                </div>

                <div className="row mechanics-border-third">
                  <div className="col-lg-6 col-md-6 third-dotted-spaced">
                    <div className="macheincs-content number-three">
                      <h3>Credit History Check</h3>
                      <p>
                        Let our advanced systems analyze your credit profile and
                        match you with lenders who align with your
                        creditworthiness.
                      </p>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="macheincs-content imagepart">
                      <img
                        src={CreditHistory}
                        alt="CreditHistory"
                        loading="lazy"
                      />
                    </div>
                  </div>
                </div>
                <div className="row mechanics-border-fourth">
                  <div className="col-lg-6 col-md-6 fourth-dotted-spaced order-sec-2">
                    <div className="macheincs-content imagepart">
                      <img src={OnlineDoc} alt="OnlineDoc" loading="lazy" />
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6 mechanics-border-second">
                    <div className="macheincs-content number-four">
                      <h3>Loan Approval Notification</h3>
                      <p>
                        {" "}
                        Celebrate as your dream lender approves your loan
                        application, bringing you one step closer to realizing
                        your financial goals.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className="whychooseus-section" ref={aboutRef}>
            <div className="whyChoose-inner">
              <div className="container">
                <div className="row">
                  <div className="col-md-12">
                    <h2 className="green-border">
                      What differentiates us from others?
                    </h2>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <div className="why-choose-left">
                      <img src={WhyChoose} alt="WhyChoose" loading="lazy" />
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="why-choose-right">
                      <div className="why-ChooseText">
                        <img className="whyicons" src={Bank} alt="Bank" />
                        <div className="text-why">
                          <h3>Lowest Bank Fees</h3>
                          <p>
                            Enjoy unbeatable rates and keep more of your
                            hard-earned money in your pocket.
                          </p>
                        </div>
                      </div>

                      <div className="why-ChooseText">
                        <img className="whyicons" src={Money} alt="Money" />
                        <div className="text-why">
                          <h3>Loans up to ₹1 Crore</h3>
                          <p>
                            {" "}
                            Access substantial funding to support your ambitious
                            plans.
                          </p>
                        </div>
                      </div>

                      <div className="why-ChooseText">
                        <img className="whyicons" src={EasyWay} alt="EasyWay" />
                        <div className="text-why">
                          <h3> Easy Application Process</h3>
                          <p>
                            {" "}
                            Our user-friendly platform simplifies the loan
                            journey, making it a breeze.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section className="recomment-Friend">
            <div className="inner-recomment-Friend">
              <div className="container">
                <div className="row">
                  <div className="col-md-6">
                    <div className="recommend-img">
                      <img
                        src={ReferImage}
                        className="recommetnImgsd"
                        alt="ReferImage"
                        loading="lazy"
                      />
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="eagertoForge">
                      <h2>
                        Forging Friendships on the Path to Financial Freedom
                      </h2>
                      <p>
                        We are a community of people brought together by a
                        common interest in financial empowerment, rather than
                        merely being a lending platform. As we move forward,
                        we're excited to make new connections and encourage one
                        another in our shared pursuit of financial freedom.
                      </p>
                      <div className="refer-btn">
                        <Link to="#">Recommend To Friend</Link>
                      </div>
                      <div className="earn-btn">
                        <span className="earnIcons">₹</span>Earn Rewards
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className="testimonilas-Section">
            <div className="testimonilas-inner">
              <div className="container">
                <div className="row">
                  <div className="col-md-12">
                    <h2 className="green-border white-border">
                      VOICE OF OUR CUSTOMERS
                    </h2>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <div className="muyowl-slider">
                      <Carousel
                        className="owl-theme"
                        responsive={responsive}
                        infinite
                        autoPlay
                        autoPlaySpeed={3000}
                        arrows
                        showDots={false}
                      >
                        {owlCarouselItems.map((items) => (
                          <div className="item" key={items.id}>
                            <div className="testimonilas-content">
                              <img
                                className={
                                  items.img === ProfileIcons1
                                    ? "profielUsersr1"
                                    : "profielUsersr"
                                }
                                src={items.img}
                                alt="ProfileIcons"
                              />
                              <div className="testimonial-cot">
                                {items.userReview}
                                {items.userName}
                                <p className="starts">★★★★★</p>
                              </div>
                            </div>
                          </div>
                        ))}
                      </Carousel>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className="spreading-smileSection">
            <div className="spreading-inner">
              <div className="container">
                <div className="row">
                  <div className="col-md-12">
                    <h2>SPREADING SMILES ALL THE WAY…</h2>
                  </div>
                </div>
              </div>
            </div>
            <div className="kpiSection">
              <div className="container">
                <div className="row">
                  <div className="col-lg-3 col-md-6 col-sm-6">
                    <div className="kpibox">
                      <img src={EnquiryIcon} alt="EnquiryIcon" />
                      <h3>
                        <CountUp end={5}>
                          {({ countUpRef, start }) => (
                            <VisibilitySensor onChange={start} delayedCall>
                              <span ref={countUpRef} />
                            </VisibilitySensor>
                          )}
                        </CountUp>{" "}
                        Lakhs
                      </h3>
                      <p>Inquiries</p>
                    </div>
                  </div>

                  <div className="col-lg-3 col-md-6 col-sm-6">
                    <div className="kpibox">
                      <img src={LoanProcessed} alt="LoanProcessed" />
                      <h3>
                        <CountUp end={2}>
                          {({ countUpRef, start }) => (
                            <VisibilitySensor onChange={start} delayedCall>
                              <span ref={countUpRef} />
                            </VisibilitySensor>
                          )}
                        </CountUp>{" "}
                        Lakh
                      </h3>
                      <p>Loans Processed</p>
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-6 col-sm-6">
                    <div className="kpibox">
                      <img src={EnquiryIcon} alt="EnquiryIcon" />
                      <h3>
                        <CountUp end={70}>
                          {({ countUpRef, start }) => (
                            <VisibilitySensor onChange={start} delayedCall>
                              <span ref={countUpRef} />
                            </VisibilitySensor>
                          )}
                        </CountUp>
                      </h3>
                      <p>Partner Banks</p>
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-6 col-sm-6">
                    <div className="kpibox">
                      <img src={UsersIcons} alt="UsersIcons" />
                      <h3>
                        <CountUp end={5}>
                          {({ countUpRef, start }) => (
                            <VisibilitySensor onChange={start} delayedCall>
                              <span ref={countUpRef} />
                            </VisibilitySensor>
                          )}
                        </CountUp>{" "}
                        K+
                      </h3>
                      <p>Happy Users</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
      <Footer />
      {/*<ContactModal show={showModal} handleClose={() => setShowModal(false)} />*/}
      <ToastContainer />
    </>
  );
}

export default Home;
